import React from 'react';

export default function SupportLink() {
  const supportEmailAddress = "support@pto.football";

  return (
    <a href={`mailto:${supportEmailAddress}`}>{supportEmailAddress}</a>
  );
};